module.exports = __webpack_public_path__ + "band_7.3eb52c47.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_7.png
// module id = Cp3P
// module chunks = 0